// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609210529/js/" + chunkId + "." + {"44":"b23d7165","225":"576a0f63","481":"baa64c74","486":"e68b2330","770":"d990fc97"}[chunkId] + ".0.6046156163304791.chunk.js";
};